module.exports = function (done, value) {
  return { value: value, done: !!done };
};



//////////////////
// WEBPACK FOOTER
// /~/babel-polyfill/~/core-js/modules/_iter-step.js
// module id = 247
// module chunks = 31